import React, { useEffect } from "react";
import LaundryItemListing from "./pages/LaundryItemListing";

function LaundryItem(props) {
    const { setActive } = props;
    useEffect(() => {
      //setActive(3);
    }, []);

    return <LaundryItemListing />
};

export default LaundryItem;